export const exterior_view06ImageOptions = {
  angle: 'exterior_view06',
  staticOptions: {
    BowSpirit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    Sprayhood: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    BathingPlatform: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/XP44/views/exterior_view06.js